export class Guest {
  id: number = null;
  preorderedDiys:any[] = [];
  preorderedDrinks:any[] = [];
  nickname: string = "";
  email: string = "";

  /** Csak fronenden létező tulajdonságok */
  notified: boolean = false;

  /** BackendÁltal küldött szükséges tulajdonságok */
  accessToken: string;

  constructor(nickname) {
    this.nickname = nickname
  }
}
